import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ReponseCoordonneesCreditService } from '../../services/reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpStatusCode } from '@angular/common/http';
import { CybermetrieCoordonneesService } from '../../services/cybermetrie/cybermetrie.service';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { AccessibiliteService } from '../../services/accessibilite.service';

@Component({
  selector: 'app-page-erreur',
  templateUrl: './page-erreur.component.html',
  standalone: false,
})
export class PageErreurComponent implements OnInit, AfterViewInit {
  titre = '';
  titreTraduit = '';
  status: string = '';
  estErreurSysteme = false;
  codeErreur = '';
  messageErreur = '';
  libelleHandle: string = '';

  constructor(
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService,
    private readonly translateService: TranslateService,
    private readonly cybermetrieService: CybermetrieCoordonneesService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly gestionTitreService: GestionTitreService,
    private readonly accessibiliteService: AccessibiliteService,
    router: Router
  ) {
    this.status = router.getCurrentNavigation()?.extras?.state?.status as string;
    this.codeErreur = router.getCurrentNavigation()?.extras?.state?.codeErreur as string;
    this.messageErreur = router.getCurrentNavigation()?.extras?.state?.messageErreur as string;
  }

  ngOnInit(): void {
    this.estErreurSysteme = this.status !== HttpStatusCode.ServiceUnavailable.toString();
    this.activatedRoute.data.subscribe((data) => {
      this.libelleHandle = data.libelleHandle;
      this.titre = this.getTitre();
      this.gestionTitreService.addTitreOnglet(
        this.estErreurSysteme ? this.getTitreOnglet() : this.getTitreOngletNonDisponible()
      );
    });
    this.translateService.get(this.titre).subscribe((texte: string) => (this.titreTraduit = texte));
    const texteErreurs: string[] = [this.codeErreur, this.messageErreur];
    this.cybermetrieService.transactionErreurTechnique(texteErreurs, this.isVueCoordonneesBancaire());
  }

  ngAfterViewInit(): void {
    this.accessibiliteService.setFocus('#messageErreur');
  }

  get messageErreurSysteme(): string {
    return `caad.page-erreur-${this.contexteErreur}.messageErreurSysteme`;
  }

  get messageErreurFonctionNonDisponible(): string {
    return `caad.page-erreur-${this.contexteErreur}.messageErreurFonctionNonDisponible`;
  }

  private get contexteErreur(): string {
    return this.isVueCoordonneesBancaire() ? 'bancaire' : 'fiserv';
  }

  private getTitre(): string {
    if (this.isVueCoordonneesBancaire()) {
      return 'caad.accueil.titreServiceCarteCredit';
    }
    return this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()
      ? 'caad.titreMulticarte'
      : 'caad.titre';
  }

  private getTitreOngletNonDisponible(): string {
    if (this.isVueCoordonneesBancaire()) {
      return 'caad.titreOnglet.page-erreur';
    }
    if (this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()) {
      return 'caad.titreOnglet.erreurNonDisponibleFiserv.titreMulticarte';
    }
    return 'caad.titreOnglet.erreurNonDisponibleFiserv.titre';
  }

  private getTitreOnglet(): string {
    if (this.isVueCoordonneesBancaire()) {
      return 'caad.titreOnglet.page-erreur';
    }
    if (this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn()) {
      return 'caad.titreOnglet.erreurFiserv.titreMulticarte';
    }
    return 'caad.titreOnglet.erreurFiserv.titre';
  }

  isVueCoordonneesBancaire(): boolean {
    return this.libelleHandle === 'coordonnees';
  }
}
